import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'

import Home from './pages/Home'
import CocktailDetails from './pages/CocktailDetails'

class App extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" exact="true" element={<Home />} />
          <Route
            path="/cocktail/:id"
            exact="true"
            element={<CocktailDetails />}
          />
          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </BrowserRouter>
    )
  }
}

export default App
